import { PasswordResetForm } from "@/components/forms/password-reset-formt";
import AuthLayout from "@/layouts/auth_layout";
import { useTranslation } from "react-i18next";

interface ForgotPasswordPageProps {
  token: string;
}

export default function ForgotPasswordPage({
  token,
}: Readonly<ForgotPasswordPageProps>) {
  const { t } = useTranslation();
  return (
    <AuthLayout
      headingInContent
      title={t("auth.forgot_title")}
      description={t("auth.forgot_description")}
    >
      <PasswordResetForm token={token} />
    </AuthLayout>
  );
}
